import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Molecule exibida no grid de matrículas quando ainda não houve nenhuma busca.
 * Diferencia-se do `EmptyState` (que sinaliza "sem resultados") por orientar o
 * usuário a preencher filtros e clicar em "Buscar".
 */
export function EnrollmentSearchPrompt() {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col w-full bg-ctx-layout-surface rounded-md items-center justify-center gap-xxs py-xxl text-center">
      <div className="flex h-xxl w-xxl items-center justify-center rounded-circular bg-ctx-interactive-secondary">
        <MagnifyingGlassIcon className="h-md w-md text-ctx-interactive-primary" />
      </div>

      <div className="flex flex-col gap-xxxs">
        <p className="text-ctx-content-title ts-subtitle-xs">
          {t('enrollmentList.searchPrompt.title')}
        </p>
        <p className="max-w-sm text-ctx-content-placeholder ts-caption-xxs">
          {t('enrollmentList.searchPrompt.description')}
        </p>
      </div>
    </div>
  );
}
